module.exports = __webpack_public_path__ + "static/media/minigelatinas1.2378ec54.JPG";